<template>
  <div>
    <v-card outlined class="card-alerts" :height="400">
      <v-card-title class="card-title-alerts"> Alerts </v-card-title>
      <v-card-text class="card-content-alerts">
        <exo-input-ref-multiple
          :root="_self"
          name="alertDefinitions"
          :isParametric="false"
          type="alertDefinitions"
          componentRoute="/abstractalertdefinition"
        ></exo-input-ref-multiple>

        <ScreeningCatalogueAlertsTable
          :alerts="inputs.alertDefinitions"
          style="width: 100%"
        /> </v-card-text
    ></v-card>
    <v-card
      v-if="listAlertsWithSpaceObjectNull.length != 0"
      style="margin-top: 10px"
      ><v-card-title style="background-color: red"> Alert : </v-card-title>
      <v-card-text>
        <p v-for="alert in listAlertsWithSpaceObjectNull" :key="alert.name">
          " {{ alert.name }} ": doesn't have space object group selected (it
          might have been deleted). You must update this alert before saving or
          computing your mission.
        </p></v-card-text
      >
    </v-card>
  </div>
</template>

<script>
import axios from '../../services/axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import errorMixin from '../../mixins/logHandler.js'
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import dataTools from '../../tools/data.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import ScreeningCatalogueAlertsTable from './ScreeningCatalogueAlertsTable.vue'
import ScreeningAlertComponent from './ScreeningAlertComponent'
import defense from '../../mixins/defense'
import { mapActions } from 'vuex'
Vue.use(VueAxios, axios)

export default {
  name: 'TLEScreeningRequest',
  mixins: [errorMixin, formMixin, numericalMixin, defense],
  props: {
    tleScreeningRequest: { type: Object }
  },
  data() {
    return {
      alertDefinitionssNotParametrics: [],
      inputs: {
        name: this.getDefaultValue('name'),
        alertDefinitions: [],
        typeName: this.getDefaultValue('typeName'),
        description: this.getDefaultValue('description'),
        spaceObjectsMeasurements: this.getDefaultValue(
          'spaceObjectsMeasurements'
        )
      },
      listAlertsWithSpaceObjectNull: []
    }
  },

  components: { ScreeningCatalogueAlertsTable },

  created() {},

  mounted() {
    this.refreshReferences()
  },
  watch: {
    'inputs.alertDefinitions'(newValue) {
      let newListAlertsWithSpaceObjectNull = []
      for (const alert of newValue) {
        if (alert == null) {
          this.inputs.alertDefinitions = []
        } else {
          if (
            alert.primarySpaceObjectGroups?.length === 0 ||
            (alert.primarySpaceObjectGroups?.length === 1 &&
              alert.primarySpaceObjectGroups[0] === null)
          ) {
            newListAlertsWithSpaceObjectNull.push(alert)
          }

          if (
            alert.secondarySpaceObjectGroups?.length === 0 ||
            (alert.secondarySpaceObjectGroups?.length === 1 &&
              alert.secondarySpaceObjectGroups[0] === null)
          ) {
            newListAlertsWithSpaceObjectNull.push(alert)
          }
        }
      }
      this.listAlertsWithSpaceObjectNull = newListAlertsWithSpaceObjectNull
      this.$emit('update:tleScreeningRequest', this.inputs)
    },

    tleScreeningRequest(newValue) {
      this.copyLocalFields(newValue)
    },
    alertDefinitionssNotParametrics(newValue) {
      const listAlerts = newValue.map((alertField) => alertField.value)
      let newListAlert = []
      for (const alert of this.inputs.alertDefinitions) {
        for (const alertFromList of listAlerts) {
          if (alert.id === alertFromList.id) {
            newListAlert.push(alertFromList)
          }
        }
      }
      this.inputs.alertDefinitions = newListAlert
    }
  },
  computed: {},
  methods: {
    ...mapActions(['setScreeningAlerts']),
    refreshReferences() {
      this.refreshAlertDefinitions()
    },
    refreshAlertDefinitions() {
      let self = this
      this.$http
        .get(this.getAPI('abstractalertdefinitions'))
        .then((response) => {
          self.alertDefinitionssNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of alert. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getCurrentFormType() {
      return 'TLEScreeningRequest'
    },
    getSubTypes(instance) {},

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },
    getRefList(param) {
      if (param === 'alertDefinitions') {
        return this.alertDefinitionssNotParametrics
      }
    },
    isExoInputMultipleWithoutForm(item) {
      return item === 'alertDefinitions'
    },
    saveForParentComponent(editedItem) {
      let copyAlertsDefinition = [...this.inputs.alertDefinitions]
      let isInclude = false
      for (let i = 0; i < copyAlertsDefinition.length; i++) {
        if (copyAlertsDefinition[i].id === editedItem.id) {
          isInclude = true
          copyAlertsDefinition[i] = editedItem
        }
      }
      if (isInclude == true) {
        this.setScreeningAlerts(copyAlertsDefinition)
      } else {
        this.setScreeningAlerts([...this.inputs.alertDefinitions, editedItem])
      }
    }
  }
}
</script>

<style scoped>
.card-title-alerts {
  justify-content: center;
  align-content: center;
  font-size: small;
  border-bottom: 2px solid;
  border-color: black;
  height: 15px;
}

.card-alerts {
  border: 2px solid;
  border-color: black;
  height: 350px;
  overflow-y: scroll;
  scrollbar-width: none;
}
</style>
